<template>
  <div class="card card-fluid shadow-none border-0">
    <div class="card-body p-0">
      <div class="table-responsive">
        <dynamic-table
          :columns="columns"
          :data="dictums"
          :loading="loading"
          class="table-hover"
          theadClass="thead-light"
          empty-message="No existen dictámenes registrados"
        >
          <template v-slot:type.title="slotProps">
            <span v-if="slotProps.row.type.title === 'Aprobado'"
                class="badge badge-success">{{ slotProps.row.type.title }}</span>
            <span
                v-else-if="slotProps.row.type.title === 'No aprobado' || slotProps.row.type.title === 'Rechazado'"
                class="badge badge-subtle badge-danger">{{ slotProps.row.type.title }}</span>
            <span v-else
                class="badge badge-subtle badge-dark">{{ slotProps.row.type.title }}</span>
          </template>

          <template v-slot:comments="slotProps">
            <button
              @click.prevent="showComments(slotProps.row.comments)"
              class="btn btn-sm btn-outline-primary d-block"
              style="white-space: nowrap"
            >
              Ver comentarios
            </button>
          </template>
        </dynamic-table>
      </div>
    </div>

    <ok-cancel-dialog
      :id="`show-amendment-dictums-modal-${uuid}`"
      ref="show-amendment-dictums-modal"
      title="Comentarios"
      :show-ok-button="false"
      cancel-button-text="Aceptar"
      backdrop="normal"
      :keyboard="'true'"
      scrollable
      large
      :content="comments"
    ></ok-cancel-dialog>

    <modify-dictum-file-modal
      :id="`modify-file-modal-${uuid}`"
      :ref="`modify-file-modal-${uuid}`"
      title="Modificar archivo de dictamen"
      :dictum="dictum"
      :amendment="amendment"
      v-if="amendment"
      @file-updated="load"
    ></modify-dictum-file-modal>
  </div>
</template>

<script>
import DynamicTable from "../ui/DynamicTable";
import OkCancelDialog from "../ui/OkCancelDialog";
import ModifyDictumFileModal from "../amendments/ModifyDictumFileModal";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AmendmentReviewerDictums",
  components: {
    DynamicTable,
    OkCancelDialog,
    ModifyDictumFileModal,
  },
  props: {
    amendment: Object,
  },
  data() {
    return {
      loading: false,
      dictums: [],
      comments: "",
      uuid: null,
      dictum: null,
      columns: [
        {
          field: "reviewer.full_name",
          title: "Revisor",
          tdClass: "text-left text-truncate",
          tdStyle: {},
          thClass: "align-middle",
          thStyle: {},
          width: "200",
        },
        {
          field: "committee.name",
          title: "Comité",
          tdClass: "text-left text-truncate",
          tdStyle: {},
          thClass: "align-middle",
          thStyle: {},
          width: "200",
        },
        {
          field: "type.title",
          title: "Dictamen",
          tdClass: "text-left",
          tdStyle: {},
          thClass: "align-middle",
          thStyle: {},
        },
        {
          field: "dictum_date",
          title: "Fecha dictamen",
          tdClass: "text-left",
          tdStyle: {},
          thClass: "align-middle",
          thStyle: {},
        },
        {
          field: "comments",
          title: "Comentarios",
          tdClass: "text-center",
          tdStyle: {},
          thClass: "align-middle",
          thStyle: {},
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      getReviewersDictums: "amendments/getReviewersDictums",
    }),

    async load() {
      this.loading = true;

      const response = await this.getReviewersDictums({
        amendment: this.amendment,
      });

      this.dictums = response.data;

      this.loading = false;
    },

    showComments(comments) {
      this.comments = comments;

      $(`#show-amendment-dictums-modal-${this.uuid}`).modal("show");
    },

    showModifyFileModal(data) {
      this.dictum = data.id;

      $(`#modify-file-modal-${this.uuid}`).modal("show");
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
  created() {
    this.uuid = Math.guid();
  },
  async mounted() {
    await this.load();
  },
};
</script>
